import React from 'react';


function XMLUploadUnilav ({ onXmlUploaded }) {

    const handleUploadXML = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            onXmlUploaded(event.target.files[0]);
        }
      };

    return (
        <div className="w-full">
            <h3 className='text-sm text-gray-700 mb-0'>Seleziona File</h3>
    
            <form className="flex items-center space-x-6 border border-2-gray rounded-md shadow-md mt-2">
                <div className="grid grid-cols-1 w-full">
                 
                    <div className='col-span-1 w-full'>
                        <label className="block">
                
                            <input 
                                type="file"
                                className="block file:py-6 w-full text-sm text-slate-500
                                file:mr-4 file:px-4
                                file:rounded-75 file:border-0
                                file:text-sm file:font-semibold
                                file:bg-indigo-50 file:text-indigo-700
                                hover:file:bg-indigo-100
                                "
                                onChange={handleUploadXML}
                            />
                        </label>
                    </div>
                </div>
            </form>
        </div>
      )
    };


export default XMLUploadUnilav;

